var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeopleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.895 6.29956C15.2203 6.29956 16.2947 5.22515 16.2947 3.89978C16.2947 2.57442 15.2203 1.5 13.895 1.5C12.5696 1.5 11.4952 2.57442 11.4952 3.89978C11.4952 5.22515 12.5696 6.29956 13.895 6.29956Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8697 11.024C10.8242 11.1784 10.9358 11.3398 11.0968 11.3398H18.2328C18.6564 11.3398 18.9998 10.9964 18.9998 10.5728V9.77884C18.9998 8.95088 18.7347 8.15683 18.2627 7.57137C17.8567 7.06785 17.3264 6.7541 16.7613 6.67614C16.5826 6.6515 16.4075 6.72105 16.2554 6.81797C15.8824 7.05578 15.0703 7.47318 13.9661 7.47318C12.8619 7.47318 12.0499 7.05578 11.6769 6.81797C11.5248 6.72105 11.3496 6.6515 11.171 6.67614C10.8865 6.71539 10.6107 6.81444 10.3552 6.96739C10.2456 7.03304 10.2254 7.179 10.2967 7.28506C10.7728 7.99343 11.0507 8.84623 11.0507 9.76393C11.0507 10.2016 10.9875 10.6245 10.8697 11.024Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60189 12.8717C8.31771 12.8717 9.70866 11.4808 9.70866 9.76497C9.70866 8.04915 8.31771 6.6582 6.60189 6.6582C4.88607 6.6582 3.49512 8.04915 3.49512 9.76497C3.49512 11.4808 4.88607 12.8717 6.60189 12.8717Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2027 16.5775V17.5475C12.2027 17.9711 11.8593 18.3145 11.4358 18.3145H1.76698C1.34339 18.3145 1 17.9711 1 17.5475V16.5775C1 15.6562 1.29507 14.7726 1.8203 14.1211C2.27949 13.5516 2.88171 13.2002 3.52224 13.1208C3.70118 13.0987 3.87584 13.1673 4.02706 13.2655C4.42919 13.5266 5.34545 14.0119 6.60136 14.0119C7.85728 14.0119 8.77354 13.5266 9.17567 13.2655C9.32689 13.1673 9.50155 13.0987 9.68048 13.1208C10.321 13.2002 10.9232 13.5516 11.3824 14.1211C11.9077 14.7726 12.2027 15.6562 12.2027 16.5775Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIcon);
export default __webpack_public_path__ + "static/media/people-icon.f8b0e9d513ca15d4d319613a411d6fab.svg";
export { ForwardRef as ReactComponent };